module.exports = __webpack_public_path__ + "img/hipercard-v2-dark.c7e06db8.svg";